// require("./plugins/contentful-paint");
import("./plugins/menus/hamburger");

import { startSelects } from "./plugins/_select";
import { Swiper } from "./plugins/swiper-bundle.min";

var $ = require("jquery");

$(document).ready(function (e) {
	// require('./common');

	startSelects();

	var swiper = new Swiper(".mySwiper", {
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	$(".serveis ol a")
		.off("click")
		.on("click", function (e) {
			e.preventDefault();
			$(this).closest("li").toggleClass("active");
		});

	$(".socies .socia a")
		.off("click")
		.on("click", function (e) {
			e.preventDefault();
			$(".bloc7 .socia")
				.not($(this).closest(".socia"))
				.each(function () {
					$(this).removeClass("active");
				});
			$(this).closest(".socia").toggleClass("active");
		});

	console.log("carregada");
});

// document.addEventListener("DOMContentLoaded", function() {

//     // common

//     // if (document.querySelector('main.template-home')) {
//     //     import('./pages/home.js');
//     // }
//     // if (document.querySelector('main.template-page-about')) {
//     //     import('./pages/about.js');
//     // }
//     // if (document.querySelector('main.template-single-program:not(.template-single-program-landing)')) {
//     //     import('./pages/single-program.js');
//     // }
//     // if (document.querySelector('main.template-single-program-landing')) {
//     //     import('./pages/single-program-landing.js');
//     // }
//     // if (document.querySelector('main.template-single-speakers')) {
//     //     import('./pages/single-speaker.js');
//     // }
//     // if (document.querySelector('main.template-page-insights')) {
//     //     import('./pages/insights.js');
//     // }
// });
